import { fetchCsv, num, str } from './csv'
import { packageUrl } from '../data/world/package'

/** Imagen de un mapa (47_map_images.csv). Se descarga solo al abrir una ficha de mapa. */
export type MapImage = {
  mapId: number
  src: string
  width?: number
  height?: number
  /** Coordenada del servidor que avanza en horizontal / vertical (p. ej. "Y" / "X"). */
  horizontal?: string
  vertical?: string
}

let cache: Promise<Map<number, MapImage>> | undefined

export function loadMapImages(): Promise<Map<number, MapImage>> {
  if (!cache) {
    cache = fetchCsv(packageUrl('47_map_images.csv')).then(({ rows }) => {
      const m = new Map<number, MapImage>()
      rows.forEach((r) => {
        const mapId = num(r.map_id)
        const b64 = str(r.png_base64)
        if (mapId === undefined || !b64 || m.has(mapId)) return
        m.set(mapId, {
          mapId,
          src: `data:${str(r.mime_type) ?? 'image/png'};base64,${b64}`,
          width: num(r.width),
          height: num(r.height),
          horizontal: str(r.coordinate_horizontal)?.toUpperCase(),
          vertical: str(r.coordinate_vertical)?.toUpperCase(),
        })
      })
      return m
    })
    cache.catch(() => {
      cache = undefined
    })
  }
  return cache
}

/**
 * Las coordenadas de MU van de 0 a 255 por eje. Solo se dibujan marcadores si la imagen es
 * cuadrada y declara qué coordenada corresponde a cada eje (X/Y). Si no, se muestra solo la imagen.
 */
export function calibrated(img: MapImage): boolean {
  const axes = [img.horizontal, img.vertical]
  return !!img.width && img.width === img.height && axes.includes('X') && axes.includes('Y')
}
